import Vue from "vue";
import Vuex from "vuex";
import { v4 as uuid } from "uuid";

import VuexPersistence from "vuex-persist";


const vuexLocal = new VuexPersistence({
  // eslint-disable-next-line
  storage: window.localStorage,
  restoreState: (key, storage) => {
    // console.log(key);
    if (storage.vuex) {

    const vuex = JSON.parse(storage.vuex);

    const metrics = vuex.metrics;

    for (const id in metrics) {
      let metricData = metrics[id].data;

      for (let dataPoint of metricData) {
        // console.log(dataPoint);
        const newDate = new Date(dataPoint.x);
        dataPoint.x = newDate;
      }
    }

    return vuex;
  } 

  },
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    metrics: {},
  },
  mutations: {
    addMetric(state, payload) {
      // Adding a new metric, it needs a name and an id?
      let id = uuid();

      let newMetric = {
        id: id,
        name: payload.name,
        valueToAdd: null,
        data: [],
      };
      Vue.set(state.metrics, id, newMetric);

      // state.metrics = {
      //     ...state.metrics,
      //     newMetric
      // };
    },
    deleteMetric(state, payload) {
      // delete state.metrics[payload.id];
      Vue.delete(state.metrics, payload.id);
    },
    updateMetricName(state, payload) {
      // Adding a new metric, it needs a name and an id?
      let id = payload.id;
      state.metrics[id].name = payload.name;
    },
    addValue(state, payload) {
      // Adding a new metric, it needs a name and an id?
      let id = payload.id;

      let newValue = {
        x: payload.x,
        y: payload.y,
      };

      state.metrics[id].data.push(newValue);
    },
    deleteValue(state, payload) {

      // console.log("Deleting value", payload.item ,"from metric", payload.metricId);

      const itemIndex = state.metrics[payload.metricId].data.indexOf(payload.item);
      // console.log(itemIndex);
      Vue.delete(state.metrics[payload.metricId].data, itemIndex);


      // delete state.metrics[payload.id];
      
      //Vue.delete(state.metrics, payload.id);
    },
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin],
});
